import { createFileRoute } from '@tanstack/react-router';
import { TemplatesTypePage } from '../../templates/type-page.js';

export const Route = createFileRoute('/templates/$typeKey')({ component: TemplatesTypeRoute });

function TemplatesTypeRoute(): React.JSX.Element {
  const { typeKey } = Route.useParams();
  return <TemplatesTypePage typeKey={typeKey} />;
}
